// `/app/settings` (`spec/17-frontend.md` §8.1, `spec/tasks/WEB-61.md`). Sem step-up:
// `GET`/`PATCH /v1/me`.
//
// O drawer de termos tem URL (`?terms=true`, `spec/24` §1 decisão 5). Não é rota `$id`
// porque `files_allowed` desta task não inclui arquivo de rota novo, mesma solução da
// WEB-53. Ver "Questões abertas".

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { useMode } from '../app/mode.tsx';
import { StoreScreen } from '../features/account/store-screen.tsx';

const searchSchema = z.object({
  terms: z.literal(true).optional().catch(undefined),
});

function Store() {
  const { terms } = Route.useSearch();
  const navigate = useNavigate();
  const { mode } = useMode();

  return (
    <StoreScreen
      mode={mode}
      termsOpen={terms === true}
      onTermsOpenChange={(open) => {
        // Abrir e fechar o drawer é navegação de verdade: o botão de voltar tem de fechá-lo.
        void navigate({ to: '/app/settings', search: open ? { terms: true } : {} });
      }}
    />
  );
}

export const Route = createFileRoute('/app/settings/')({
  validateSearch: searchSchema,
  component: Store,
});
